import * as types from './mutation-types'

export default {
  [types.LOAD_TIME_ZONES](state, data) {
    state.timeZones = data.data
  },
}
